<template>

    <div class="container">
        <div class="table-responsive">
            <form action="/send-invite" method="post" @submit="check_form">
                <input type="hidden" name="_token" :value="csrf" />
                <table class="table table-bordered" style="border: none;">
                    <tr>
                        <th class="text-warning" :colspan="programs.length + 1">
                            Posiadane produkty
                        </th>
                    </tr>
                    <tr>
                        <td></td>
                        <td class="text-center" v-for="program in programs">{{ program.name }}</td>
                    </tr>
                    <tr>
                        <td>Stan licencji:</td>
                        <td class="text-center" v-for="program in programs">
                            <span v-if="program.active" class="text-warning">Dostęp aktywny do: {{ program.end_date }}</span>
                            <span v-if="!program.active">Dostęp wygasł: {{ program.end_date }}</span>
                        </td>
                    </tr>
                    <tr>
                        <td>Klucz licencyjny:</td>
                        <td class="text-center" v-for="program in programs">{{ program.licence_key }}</td>
                    </tr>
                    <tr>
                        <td>Ilość licencji w użyciu:</td>
                        <td class="text-center" v-for="program in programs">{{ program.accounts_used }} / {{ program.accounts_num }}</td>
                    </tr>
                    <tr>
                        <th class="text-warning" :colspan="programs.length + 1">
                            Użytkownicy
                            <button @click="add_user = true;" class="btn btn-warning ml-3" type="button">Zaproś użytkownika</button>
                        </th>
                    </tr>
                    <tr>
                        <td></td>
                        <td class="text-center" v-for="program in programs">{{ program.name }}</td>
                    </tr>
                    <tr v-if="add_user" class="table-primary">
                        <td>
                            <div class="form-group">
                                <label for="new-user-input" class="col-form-label">E-mail:</label>

                                <input type='text' name='email' id='new-user-input' class="form-control">
                            </div>
                            <button class="btn btn-warning" type="submit">Wyślij zaproszenie</button>
                        </td>
                        <td class="text-center" v-for="program in programs">
                            <div class="custom-control custom-switch">
                                <input type="checkbox" class="custom-control-input" 
                                       :id="'switch-new-' + program.id" 
                                       :name="'program_id[' + program.id + ']'"
                                       :disabled="program.accounts_used >= program.accounts_num">
                                <label class="custom-control-label" :for="'switch-new-' + program.id"></label>
                            </div>
                        </td>
                        <td style="border-color:transport;">
                            <button class="btn btn-warning" type="submit">Wyślij zaproszenie</button>
                        </td>
                    </tr>

                    <tr v-for="(user,index) in users" :key="user.id" :class="index % 2 ? 'table-primary' : ''">
                        <td>
                            {{ user.login }}
                            <i class="fas fa-ban text-danger pointer" title="Zablokuj użytkoniwka" @click='ban_user(user.id)'></i>
                        </td>
                        <td class="text-center" v-for="program in programs">
                            <div class="custom-control custom-switch">
                                <input type="checkbox" class="custom-control-input"
                                       :id="'switch-' + user.id + '-' + program.id"
                                       :checked="user.programs.indexOf(program.id) != -1"
                                       :data-program="program.id" :data-user="user.id" :data-email="user.login"
                                       :disabled="user.programs.indexOf(program.id) == -1 && program.accounts_used >= program.accounts_num"
                                       @change="checkboxChange">
                                <label class="custom-control-label" :for="'switch-' + user.id + '-' + program.id"></label>
                            </div>
                        </td>
                    </tr>

                    <tr>
                        <th class="text-danger" :colspan="programs.length + 1">
                            Zablokowani Użytkownicy
                            <button @click="block_user = true;" class="btn btn-danger ml-3" type="button">Zablokuj użytkownika</button>
                        </th>
                    </tr>
                    <tr v-if="block_user" class="table-primary">
                        <td :colspan="programs.length + 1">
                            <div class="form-group">
                                <label for="block-user-input" class="col-form-label">E-mail:</label>

                                <input type='text' id='block-user-input' class="form-control" v-model="block_user_email">
                            </div>
                            <button class="btn btn-danger" type="button" @click='ban_user(0)'>Zablokuj użytkownika</button>
                        </td>
                    </tr>
                    <tr v-for="(user,index) in blocked" :key="user.id" :class="index % 2 ? 'table-primary' : ''">
                        <td :colspan="programs.length + 1">
                            {{ user.login }}
                            <i class="fas fa-ban text-success pointer" title="Odblokuj użytkoniwka" @click='unban_user(user.id)'></i>
                        </td>
                    </tr>
                </table>
            </form>
        </div>
        <div class="modal" tabindex="-1" role="dialog">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-body">
                        <p>Usuwasz ostatnią licencje danego użytkownika. Użytkownik zostanie odpięty od Twojego konta i w celu przywrócenia go trzeba go będzie dodać ręcznie.</p>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-danger" data-dismiss="modal" @click='forceRemove'>Usuń</button>
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Anuluj</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    mounted() {
        axios.post('/my-programs-data', {})
            .then(response => {
                this.programs = response.data.programs;
                this.users = response.data.users;
                this.blocked = response.data.blocked;
            });
        },
        data: function() {
            return {
                programs: [],
                users: [],
                add_user: false,
                block_user: false,
                block_user_email: "",
                del_user_id: 0,
                del_program_id: 0,
                csrf: window.csrfToken
            }
        },
        methods: {
            actualize: function() {
                axios.post('/my-programs-data', {})
                    .then(response => {
                        this.programs = response.data.programs;
                        this.blocked = response.data.blocked;
                        var found = false;
                        for(var i in response.data.users) {
                            found = false;
                            for(var j in this.users) {
                                if (this.users[j].id == response.data.users[i].id) {
                                    this.users[j] = response.data.users[i];
                                    found = true;
                                }
                            }
                            if (!found) {
                                this.users.push(response.data.users[i]);
                            }
                        }
                        for(var j in this.users) {
                            found = false;
                            for(var i in response.data.users) {
                                if (this.users[j].id == response.data.users[i].id) {
                                    found = true;
                                }
                            }
                            if (!found) {
                                this.users[j].programs = [];
                            }
                        }
                    });
            },
            resetNewBox: function () {
                this.show_error = false;
                this.new_exists = false;
                this.add_user = false;
            },
            checkboxChange: function(event) {
                var $elem = $(event.target);
                if ($elem.is(':checked')) {
                    axios.post('/add-licence', {
                        program_id: $elem.data("program"),
                        email: $elem.data("email")
                    }).then(response => {
                        this.actualize();
                    }).catch(error => {
                        $elem.prop("checked", false);
                        this.errorHandle(error);
                    });
                } else {
                    this.del_user_id = $elem.data("user");
                    this.del_program_id = $elem.data("program");
                    axios.post('/remove-licence', {
                        program_id: $elem.data("program"),
                        user_id: $elem.data("user")
                    }).then(response => {
                        this.actualize();
                    }).catch(error => {
                        $elem.prop("checked", true);
                        this.errorHandle(error);
                        if (error.response.status == 409) {
                            $(".modal").modal('show');
                        }
                    });
                }
            },
            forceRemove: function (event) {
                axios.post('/remove-licence', {
                    program_id: this.del_program_id,
                    user_id: this.del_user_id,
                    force: true
                }).then(response => {
                    this.actualize();
                }).catch(error => {
                    $elem.prop("checked", true);
                    this.errorHandle(error);
                });
            },
            check_form: function (event) {
                if (!$("#new-user-input").val()) {
                    $(".toast-header").addClass("bg-danger text-white").removeClass("bg-success");
                    $(".toast-header .mr-auto").html("Bład");
                    $(".toast-body").html("Wypełni pole e-mail");
                    $(".toast").toast('show');
                    event.preventDefault();
                    return;
                }
                var error = true;
                for (var i in this.programs) {
                    if ($("#switch-new-" + this.programs[i].id).is(":checked")) {
                        error = false;
                        break;
                    }
                }
                if (error) {
                    $(".toast-header").addClass("bg-danger text-white").removeClass("bg-success");
                    $(".toast-header .mr-auto").html("Bład");
                    $(".toast-body").html("Zaznacz przynajmniej jeden program do skorzystania z którego chcesz zaprosić nowego użytkownika.");
                    $(".toast").toast('show');
                    event.preventDefault();
                }
            },
            ban_user: function (id) {
                if (id) {
                    axios.post('/block-user', {
                        user_id: id
                    }).then(response => {
                        this.actualize();
                    }).catch(error => {
                        this.errorHandle(error);
                    });
                } else {
                    axios.post('/block-user', {
                        email: this.block_user_email
                    }).then(response => {
                        this.actualize();
                    }).catch(error => {
                        this.errorHandle(error);
                    });
                }
            },
            unban_user: function (id) {
                axios.post('/unblock-user', {
                    user_id: id
                }).then(response => {
                    this.actualize();
                }).catch(error => {
                    this.errorHandle(error);
                });
            }
        },
}

</script>
